export default __webpack_public_path__ + "static/media/G0001.38b100b6.png";